import React, { useState } from 'react';

export default function SuggestionThumbnail({ activity, size = 'w-12 h-12' }) {
  const [imgLoaded, setImgLoaded] = useState(false);
  const imageSrc = activity.image_small || activity.og_image || activity.image;

  return (
    <div className={`${size} flex-shrink-0 rounded-lg overflow-hidden bg-gray-200 ${imgLoaded ? '' : 'shimmer'}`}>
      {imageSrc && (
        <img
          src={imageSrc}
          alt=""
          className={`w-full h-full object-cover transition-opacity duration-500 ease-out ${imgLoaded ? 'opacity-100' : 'opacity-0'}`}
          loading="lazy"
          decoding="async"
          onLoad={() => setImgLoaded(true)}
        />
      )}
    </div>
  );
}